export class ProductUtil {

	/**
	 * @param {Item} options.product
	 * @param options.profile_token
	 * @param options.organization_id
	 * @returns {URL|undefined}
	 */
	static Make_Pdf_Qr_Code_Url(options) {
		if (!options.product?.pdf) {
			return;
		}

		const qr_url = new URL("/qr", "https://bosslogics.live"); // TODO ... env variable for prod live site
		options.product?.id && qr_url.searchParams.set("product", options.product.id);

		const url = this.Make_Pdf_Url(options);
		qr_url.searchParams.set("url", url.toString());

		return qr_url;
	}

	/**
	 * @param {Item} options.product
	 * @param options.profile_token
	 * @param options.organization_id
	 * @returns {URL|undefined}
	 */
	static Make_Pdf_Url(options) {
		if (!options.product?.pdf) {
			return;
		}

		const url = new URL(options.product.pdf);
		options.profile_token && url.searchParams.set("profile", options.profile_token);
		options.organization_id && url.searchParams.set("org", options.organization_id.toString());

		return url;
	}
}